import Controller, { OnBeforeFetch, OnClick, OnMount, OnReadSuccess, OnSubmit } from '@philips-internal/oswald-ui-core/lib/client';
import {SearchPatientMealDeliveryAliases as Alias, FragmentNames} from '../../codegen'
import SearchPatientEmarController  from '../search-patient-emar/search-patient-emar-controller';
import { ClickEvent, FetchEvent, MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { FetchAPI, ToastService } from '@philips-internal/oswald-ui-components';
import { Value } from '@philips-internal/oswald-ui-core';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from './../../constants/routes';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Endpoint } from '../../constants/endpoints';
import { Placement, ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';
import DialogService from './../../services/dialog-service';

interface Department {
  departmentCode: number;
}

@Controller({ component: Alias.LAYOUT, fragment: FragmentNames.SEARCH_PATIENT_MEAL_DELIVERY })
class SearchPatientMealDeliveryController extends SearchPatientEmarController {

  @OnMount(Alias.BARCODE_COMPONENT)
  handleMountBarcode(event: MountEvent): void {
    super.handleMountBarcode(event);
  }

  @OnBeforeFetch({ target: Alias.FETCH_DEPARTMENTS })
  onBeforeFetchDepartment(evt: FetchEvent): void {
    const event = evt.target as FetchAPI;
    if (evt) {
      const params: Record<string, string | boolean> = {
        emar: false
      };
      const departamentField = this.departmentsField.getValue();

      if (departamentField) {
        params['dsSetorAtendimento'] = departamentField as string;
      }

      event.setParameters(params);
    }
  }

  @OnSubmit({ target: Alias.FILTER_PATIENTS })
  handleClickApply(event: Record<string, Value>): void {
    const record = event.record as Record<string, Value>;
    const department  = record?.departmentCode;
    const { departmentCode } = department as Department;

    this.context.set({
      departmentCode,
    });
  }

  @OnBeforeFetch({ target: Alias.PATIENT_FETCH })
  handleBeforeFetch(event: FetchEvent): void {
    const fetchApi = event.target as FetchAPI;
    const departmentCode = this.context.get('departmentCode') as string;
    fetchApi.setParameters({ departmentCode });
  }

  @OnMount(Alias.PATIENT_FETCH_MAPPER)
  patientFetchMapper(onMountEvent: MountEvent): void {
    super.patientFetchMapper(onMountEvent);
  }

  @OnClick({ target: Alias.PATIENT_FETCH_DECK })
  onCardClick(event: ClickEvent): void {
    const {nrAtendimento, cdPessoaFisica} = event.value;
    const params = {nrAtendimento, cdPessoaFisica}
    this.verifyEnconterId(params);
  }

  @OnReadSuccess({ target: Alias.BARCODE_COMPONENT })
  handleReadSuccess(event: Record<string, Value>): void {
    const patientsParams = event.item as Record<string, string>;
    const encounterId = patientsParams.value;
    this.verifyEnconterId({nrAtendimento: encounterId, cdPessoaFisica: ''});
  }

  verifyEnconterId(params: Record<string, string>): Promise<void> {
    return HttpService.get(Endpoint.VERIFY_PATIENT_TO_LIST_MEALS, { encounterId: params.nrAtendimento }).then((response) => {
      const verification = (response.body as Array<{ verification?: string; }>)[0]?.verification;
      const departmentCode = (response.body as Array<{ departmentCode?: string; }>)[0]?.departmentCode;

      if (verification) {
        switch (verification) {
          case 'S':
            this.showToast('meal-delivery.patient-without-services', ToastLevel.ERROR);
            break;
          case 'DD':
            this.showModal(params.nrAtendimento);
            break;
          case 'I':
            this.showToast('msg.invalid-encounter', ToastLevel.ERROR);
            break;
          default:
            applicationContext.redirect(ApplicationRoute.MEAL_DELIVERY_PATIENT, {
              departmentCode: departmentCode,
              encounterId: params.nrAtendimento,
              patientId: verification,
            });
            break;
        }
      } else {
        this.showToast('msg.invalid-encounter', ToastLevel.ERROR);
      }
    }).catch(() => {
      this.showToast('msg.invalid-encounter', ToastLevel.ERROR);
    });
  }

  showModal(encounterId: string): void {
    DialogService.open({
      descriptionDialog: 'msg.wish-continue',
      onClickCancel: () => {applicationContext.popNavigationItem();},
      onClickOk: () => {applicationContext.redirect(ApplicationRoute.MEAL_DELIVERY_PATIENT, { encounterId: encounterId });},
      titleDialog: 'tws.discharged-patient',
      titleOnCancel: 'patient-evolution.release-cancel-evolution',
      titleOnOk: 'tws.mfa.continue',
    });
  }

  showToast(message: string, level: ToastLevel): void {
    ToastService.open({
      dismissible: true,
      highlight: false,
      id: 'health-history-allergies-create',
      level,
      message,
      placement: Placement.BOTTOM,
      showIcon: true,
      timeout: 5000,
      type: ToastType.BANNER,
    });
  }
}

export default SearchPatientMealDeliveryController;
